import { render, staticRenderFns } from "./ConsumptionTableByPoint.component.vue?vue&type=template&id=45d5ed1b&"
import script from "./ConsumptionTableByPoint.component.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionTableByPoint.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports